// Translations for AGM Logistics
// Easy to extend with additional languages

export const translations = {
  hu: {
    // Header
    nav: {
      services: "Szolgáltatások",
      process: "Folyamat",
      about: "Rólunk",
      contact: "Kapcsolat",
      cta: "Ajánlatkérés",
    },
    
    // Hero
    hero: {
      overline: "Munkaerő-közvetítés",
      headline: "Betanított munkaerő raktárba és gyártásba akár",
      headlineHighlight: "72 órán belül",
      subheadline: "Teljes adminisztrációval, magyar kapcsolattartóval és kiszámítható költségekkel.",
      ctaPrimary: "Ajánlatot kérek",
      ctaSecondary: "Visszahívást kérek",
    },
    
    // Social Proof
    socialProof: {
      stats: [
        { value: "10+", label: "év tapasztalat" },
        { value: "100+", label: "munkavállaló" },
        { value: "2", label: "héten belüli indulás" },
        { value: "100%", label: "magyar tulajdon" },
      ],
      partnersTitle: "Megbízható partnereink",
      logoPlaceholder: "Logo",
    },
    
    // Services
    services: {
      overline: "Szolgáltatásaink",
      title: "Teljes körű munkaerő megoldások",
      items: [
        {
          title: "Bérmunka",
          description: "Komplett bérmunka szolgáltatások vállalatok számára saját telephelyünkön vagy az Ön telephelyén.",
          features: ["Csomagolás", "Összeszerelés", "Válogatás"],
        },
        {
          title: "Munkaerő biztosítás",
          description: "Megbízható, betanított munkaerő biztosítása rugalmas feltételekkel és gyors indulással.",
          features: ["Raktári dolgozók", "Gyártási munkaerő", "Logisztikai feladatok"],
        },
        {
          title: "Outsourcing / Admin",
          description: "Háttérirodai és ügyfélszolgálati folyamatok teljes körű kiszervezése.",
          features: ["Ügyfélszolgálat", "Adatkezelés", "Adminisztráció"],
        },
      ],
    },
    
    // Process
    process: {
      overline: "Hogyan működik",
      title: "Egyszerű folyamat, gyors indulás",
      steps: [
        { number: "01", title: "Igényfelmérés", description: "Felmérjük pontos igényeit és a szükséges munkaerő számát." },
        { number: "02", title: "Munkaerő biztosítás", description: "Kiválasztjuk és biztosítjuk a megfelelő munkavállalókat." },
        { number: "03", title: "Betanítás", description: "Az Ön igényei szerint betanítjuk a munkavállalókat." },
        { number: "04", title: "Folyamatos kontroll", description: "Folyamatosan felügyeljük és biztosítjuk a minőséget." },
      ],
    },
    
    // Why Choose Us
    whyUs: {
      overline: "Miért minket",
      title: "Miért válasszon minket?",
      experienceBadge: "év tapasztalat",
      benefits: [
        { title: "Gyors reagálás", description: "Akár 72 órán belül biztosítjuk a szükséges munkaerőt." },
        { title: "Rugalmas kapacitás", description: "Az igényekhez igazodó létszám, szezonális ingadozásokra is." },
        { title: "Teljes adminisztráció", description: "Minden papírmunkát és adminisztrációt mi intézünk Ön helyett." },
        { title: "Nincs rejtett költség", description: "Átlátható árazás, előre kalkulálható költségek." },
      ],
    },
    
    // CTA Section
    cta: {
      headline: "Kérjen ajánlatot",
      headlineHighlight: "24 órán belül",
      subheadline: "Vegye fel velünk a kapcsolatot és személyre szabott ajánlatot készítünk az Ön igényei alapján.",
      button: "Ajánlatkérés",
    },
    
    // About
    about: {
      overline: "Rólunk",
      quote: "\"100%-ban magyar tulajdonú cég. Közel 10 év tapasztalat bérmunka és ipari területen.\"",
      company: "AGM Logistics",
    },
    
    // Contact
    contact: {
      overline: "Kapcsolat",
      title: "Lépjen velünk kapcsolatba",
      infoTitle: "Elérhetőségeink",
      infoDescription: "Kérdése van? Forduljon hozzánk bizalommal! Munkatársaink készséggel állnak rendelkezésére.",
      phone: "Telefon",
      email: "Email",
      form: {
        name: "Név",
        namePlaceholder: "Az Ön neve",
        phone: "Telefonszám",
        phonePlaceholder: "+36 30 123 4567",
        message: "Üzenet",
        messagePlaceholder: "Miben segíthetünk?",
        submit: "Üzenet küldése",
        submitting: "Küldés...",
      },
    },
    
    // Footer
    footer: {
      rights: "Minden jog fenntartva.",
    },
    
    // Mobile CTA
    mobileCta: "Ajánlatot kérek",
    
    // Modal
    modal: {
      quote: "Ajánlatkérés",
      callback: "Visszahívás kérés",
      description: "Töltse ki az alábbi űrlapot és hamarosan felvesszük Önnel a kapcsolatot.",
      submit: "Küldés",
      submitting: "Küldés...",
    },
    
    // Toast messages
    toast: {
      success: "Köszönjük megkeresését! Hamarosan felvesszük Önnel a kapcsolatot.",
      error: "Hiba történt. Kérjük, próbálja újra később.",
    },
  },
  
  en: {
    // Header
    nav: {
      services: "Services",
      process: "Process",
      about: "About",
      contact: "Contact",
      cta: "Get Quote",
    },
    
    // Hero
    hero: {
      overline: "Workforce Solutions",
      headline: "Trained workforce for warehouse and manufacturing within",
      headlineHighlight: "72 hours",
      subheadline: "Complete administration, Hungarian contact person, and predictable costs.",
      ctaPrimary: "Request Quote",
      ctaSecondary: "Request Callback",
    },
    
    // Social Proof
    socialProof: {
      stats: [
        { value: "10+", label: "years of experience" },
        { value: "100+", label: "employees" },
        { value: "2", label: "weeks to start" },
        { value: "100%", label: "Hungarian owned" },
      ],
      partnersTitle: "Trusted by leading companies",
      logoPlaceholder: "Logo",
    },
    
    // Services
    services: {
      overline: "Our Services",
      title: "Complete workforce solutions",
      items: [
        {
          title: "Contract Work",
          description: "Complete contract work services for companies at our facility or at your location.",
          features: ["Packaging", "Assembly", "Sorting"],
        },
        {
          title: "Workforce Supply",
          description: "Reliable, trained workforce with flexible terms and quick start.",
          features: ["Warehouse workers", "Manufacturing labor", "Logistics tasks"],
        },
        {
          title: "Outsourcing / Admin",
          description: "Complete outsourcing of back-office and customer service processes.",
          features: ["Customer service", "Data management", "Administration"],
        },
      ],
    },
    
    // Process
    process: {
      overline: "How It Works",
      title: "Simple process, quick start",
      steps: [
        { number: "01", title: "Needs Assessment", description: "We assess your exact needs and the required workforce." },
        { number: "02", title: "Workforce Supply", description: "We select and provide the right employees for you." },
        { number: "03", title: "Training", description: "We train the workers according to your requirements." },
        { number: "04", title: "Ongoing Control", description: "We continuously monitor and ensure quality." },
      ],
    },
    
    // Why Choose Us
    whyUs: {
      overline: "Why Us",
      title: "Why choose us?",
      experienceBadge: "years of experience",
      benefits: [
        { title: "Fast Response", description: "We provide the required workforce within 72 hours." },
        { title: "Flexible Capacity", description: "Workforce adjusted to your needs, including seasonal fluctuations." },
        { title: "Full Administration", description: "We handle all paperwork and administration for you." },
        { title: "No Hidden Costs", description: "Transparent pricing with predictable costs." },
      ],
    },
    
    // CTA Section
    cta: {
      headline: "Get a quote within",
      headlineHighlight: "24 hours",
      subheadline: "Contact us and we'll prepare a personalized offer based on your needs.",
      button: "Request Quote",
    },
    
    // About
    about: {
      overline: "About Us",
      quote: "\"100% Hungarian-owned company. Nearly 10 years of experience in contract work and industrial services.\"",
      company: "AGM Logistics",
    },
    
    // Contact
    contact: {
      overline: "Contact",
      title: "Get in touch with us",
      infoTitle: "Contact Information",
      infoDescription: "Have questions? Feel free to reach out! Our team is ready to help you.",
      phone: "Phone",
      email: "Email",
      form: {
        name: "Name",
        namePlaceholder: "Your name",
        phone: "Phone Number",
        phonePlaceholder: "+36 30 123 4567",
        message: "Message",
        messagePlaceholder: "How can we help you?",
        submit: "Send Message",
        submitting: "Sending...",
      },
    },
    
    // Footer
    footer: {
      rights: "All rights reserved.",
    },
    
    // Mobile CTA
    mobileCta: "Request Quote",
    
    // Modal
    modal: {
      quote: "Request Quote",
      callback: "Request Callback",
      description: "Fill out the form below and we'll contact you shortly.",
      submit: "Submit",
      submitting: "Sending...",
    },
    
    // Toast messages
    toast: {
      success: "Thank you for your inquiry! We will contact you shortly.",
      error: "An error occurred. Please try again later.",
    },
  },
};

export const languages = [
  { code: "hu", label: "HU", fullName: "Magyar" },
  { code: "en", label: "EN", fullName: "English" },
];

export const defaultLanguage = "hu";
